
import TransMap from '@/components/TransMapCtd'
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: 'GoodsTrackingMap',
components: {
TransMap
},
data() {
return {
mapParams: null
}
},
created() {
let params = this.$route.query.params;
console.log('tracking_map', params)
this.mapParams = JSON.parse(decodeURIComponent(params));
}
}



// WEBPACK FOOTER //
// ./src/pages/ctd/GoodsTrackingMap.vue